export default __webpack_public_path__ + "media/color/jpy-6cd6fae7.svg";